import { KPICard, Agent, Alert, FleetStatus, WasteMetric, PipelineRisk, NavigationModule } from '@/types';

export const kpiCards: KPICard[] = [
  {
    id: 'pipeline',
    label: 'Loans in Pipeline',
    value: '2,847',
    trend: { direction: 'up', percentage: 12.3, period: '30d' },
    status: 'healthy'
  },
  {
    id: 'fleet-health',
    label: 'Fleet Health',
    value: '94%',
    trend: { direction: 'up', percentage: 2.1, period: '7d' },
    status: 'healthy'
  },
  {
    id: 'otto-match',
    label: 'Otto Match Rate',
    value: '87.2%',
    trend: { direction: 'down', percentage: 1.8, period: '24h' },
    status: 'warning'
  },
  {
    id: 'friction-index',
    label: 'Friction Index',
    value: '3.2',
    trend: { direction: 'down', percentage: 8.7, period: '30d' },
    status: 'healthy'
  },
  {
    id: 'cycle-time',
    label: 'Cycle Time',
    value: '18.5d',
    trend: { direction: 'down', percentage: 4.2, period: '30d' },
    status: 'healthy'
  },
  {
    id: 'active-agents',
    label: 'Active Agents',
    value: '42',
    trend: { direction: 'up', percentage: 7.1, period: '7d' },
    status: 'healthy'
  }
];

export const navigationModules: NavigationModule[] = [
  { id: 'command-center', label: 'Command Center', icon: 'BarChart3', path: '/' },
  { id: 'otto', label: 'Otto', icon: 'Brain', path: '/otto' },
  { id: 'ally', label: 'Ally', icon: 'MessageCircle', path: '/ally' },
  { id: 'fleet', label: 'Fleet', icon: 'Users', path: '/fleet' },
  { id: 'kronos', label: 'Kronos', icon: 'Clock', path: '/kronos' },
  { id: 'foundation', label: 'Foundation', icon: 'Database', path: '/foundation' },
  { id: 'analytics', label: 'Analytics', icon: 'TrendingUp', path: '/analytics' },
  { id: 'channels', label: 'Channels', icon: 'Layers', path: '/channels' },
  { id: 'admin', label: 'Admin', icon: 'Settings', path: '/admin' }
];

export const fleetAgents: Agent[] = [
  {
    id: 'otto-core',
    name: 'Otto',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'AI Underwriting Engine - Core platform for loan decisioning',
    tags: ['underwriting', 'core', 'production'],
    lastUpdated: '2024-04-11T10:30:00Z',
    performance: { reliability: 98, efficiency: 94, satisfaction: 96 }
  },
  {
    id: 'ally-chat',
    name: 'Ally',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'AI Assistant for customer service and internal support',
    tags: ['chat', 'support', 'customer-service'],
    lastUpdated: '2024-04-11T09:15:00Z',
    performance: { reliability: 99, efficiency: 92, satisfaction: 98 }
  },
  {
    id: 'kitt-personal',
    name: 'KITT',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Personal AI assistant for executives and IT management',
    tags: ['personal', 'executive', 'management'],
    lastUpdated: '2024-04-11T11:45:00Z',
    performance: { reliability: 97, efficiency: 96, satisfaction: 99 }
  },
  {
    id: 'marcus-analysis',
    name: 'Marcus',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Advanced analytics and business intelligence AI',
    tags: ['analytics', 'bi', 'reporting'],
    lastUpdated: '2024-04-11T08:20:00Z',
    performance: { reliability: 96, efficiency: 89, satisfaction: 94 }
  },
  {
    id: 'sage-compliance',
    name: 'SAGE',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Smart Automated Guidance Engine for compliance monitoring',
    tags: ['compliance', 'monitoring', 'guidance'],
    lastUpdated: '2024-04-11T07:30:00Z',
    performance: { reliability: 99, efficiency: 91, satisfaction: 95 }
  },
  {
    id: 'verdict-validation',
    name: 'VERDICT',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Verification and Risk Detection in Credit Transactions',
    tags: ['verification', 'risk', 'credit'],
    lastUpdated: '2024-04-11T12:00:00Z',
    performance: { reliability: 98, efficiency: 93, satisfaction: 97 }
  },
  {
    id: 'mtl-tracker',
    name: 'MTL',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Milestone Tracking and Loan lifecycle management',
    tags: ['tracking', 'lifecycle', 'milestones'],
    lastUpdated: '2024-04-11T10:15:00Z',
    performance: { reliability: 97, efficiency: 88, satisfaction: 92 }
  },
  {
    id: 'orion-wholesale',
    name: 'Orion',
    tier: 'Channel',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Wholesale channel management and broker relations AI',
    tags: ['wholesale', 'brokers', 'channel'],
    lastUpdated: '2024-04-11T09:45:00Z',
    performance: { reliability: 94, efficiency: 87, satisfaction: 89 }
  },
  {
    id: 'violet-super',
    name: 'Violet',
    tier: 'Channel',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Super Loans platform AI for premium loan products',
    tags: ['premium', 'super-loans', 'channel'],
    lastUpdated: '2024-04-11T11:20:00Z',
    performance: { reliability: 93, efficiency: 85, satisfaction: 91 }
  },
  {
    id: 'kronos-ops',
    name: 'Kronos',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Operations management and workflow automation',
    tags: ['operations', 'workflow', 'automation'],
    lastUpdated: '2024-04-11T08:50:00Z',
    performance: { reliability: 91, efficiency: 83, satisfaction: 86 }
  },
  {
    id: 'coroner-analysis',
    name: 'CORONER',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Comprehensive Operations Review and Efficiency Reporting',
    tags: ['analysis', 'efficiency', 'reporting'],
    lastUpdated: '2024-04-11T07:45:00Z',
    performance: { reliability: 95, efficiency: 90, satisfaction: 93 }
  },
  {
    id: 'fallout-predictor',
    name: 'FALLOUT',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Pipeline risk assessment and loan fallout prediction',
    tags: ['prediction', 'risk', 'pipeline'],
    lastUpdated: '2024-04-11T10:45:00Z',
    performance: { reliability: 89, efficiency: 86, satisfaction: 88 }
  },
  // Additional agents to reach 40+ as specified
  {
    id: 'apollo-pricing',
    name: 'Apollo',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Dynamic pricing and rate optimization engine',
    tags: ['pricing', 'rates', 'optimization'],
    lastUpdated: '2024-04-11T09:30:00Z',
    performance: { reliability: 92, efficiency: 88, satisfaction: 90 }
  },
  {
    id: 'athena-strategy',
    name: 'Athena',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Strategic analysis and market intelligence AI',
    tags: ['strategy', 'market', 'intelligence'],
    lastUpdated: '2024-04-11T08:15:00Z',
    performance: { reliability: 87, efficiency: 84, satisfaction: 85 }
  },
  {
    id: 'hermes-comm',
    name: 'Hermes',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Communication routing and notification management',
    tags: ['communication', 'routing', 'notifications'],
    lastUpdated: '2024-04-11T11:10:00Z',
    performance: { reliability: 94, efficiency: 91, satisfaction: 93 }
  },
  {
    id: 'diana-doc',
    name: 'Diana',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Document processing and intelligent extraction',
    tags: ['documents', 'processing', 'extraction'],
    lastUpdated: '2024-04-11T10:00:00Z',
    performance: { reliability: 96, efficiency: 89, satisfaction: 92 }
  },
  {
    id: 'zeus-oversight',
    name: 'Zeus',
    tier: 'Platform',
    status: 'Maintenance',
    verdictMaturity: 'Production',
    description: 'System oversight and governance automation',
    tags: ['oversight', 'governance', 'automation'],
    lastUpdated: '2024-04-10T15:30:00Z',
    performance: { reliability: 98, efficiency: 95, satisfaction: 97 }
  },
  {
    id: 'iris-visual',
    name: 'Iris',
    tier: 'Experimental',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Visual document analysis and property assessment',
    tags: ['visual', 'documents', 'assessment'],
    lastUpdated: '2024-04-11T12:15:00Z',
    performance: { reliability: 78, efficiency: 76, satisfaction: 79 }
  },
  {
    id: 'phoenix-recovery',
    name: 'Phoenix',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Loan recovery and collections optimization',
    tags: ['recovery', 'collections', 'optimization'],
    lastUpdated: '2024-04-11T09:00:00Z',
    performance: { reliability: 93, efficiency: 87, satisfaction: 89 }
  },
  {
    id: 'prometheus-predict',
    name: 'Prometheus',
    tier: 'Experimental',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Predictive analytics and forecasting engine',
    tags: ['predictive', 'forecasting', 'analytics'],
    lastUpdated: '2024-04-11T11:30:00Z',
    performance: { reliability: 81, efficiency: 79, satisfaction: 82 }
  },
  {
    id: 'jett-outreach',
    name: 'Jett',
    tier: 'Channel',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Automated outreach and borrower engagement engine',
    tags: ['outreach', 'engagement', 'borrower'],
    lastUpdated: '2024-04-11T10:50:00Z',
    performance: { reliability: 95, efficiency: 90, satisfaction: 93 }
  },
  {
    id: 'bach-creative',
    name: 'Bach',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Creative content and marketing material generation',
    tags: ['creative', 'marketing', 'content'],
    lastUpdated: '2024-04-11T09:20:00Z',
    performance: { reliability: 91, efficiency: 86, satisfaction: 94 }
  },
  {
    id: 'atlas-infra',
    name: 'ATLAS',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Infrastructure automation and server management VM',
    tags: ['infrastructure', 'automation', 'servers'],
    lastUpdated: '2024-04-11T12:05:00Z',
    performance: { reliability: 99, efficiency: 97, satisfaction: 96 }
  },
  {
    id: 'jared-t1',
    name: 'Jared',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Tier 1 support agent for employee IT requests',
    tags: ['support', 'helpdesk', 'tier-1'],
    lastUpdated: '2024-04-11T11:55:00Z',
    performance: { reliability: 96, efficiency: 92, satisfaction: 95 }
  },
  {
    id: 'gil-t2',
    name: 'Gil',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Tier 2 support agent for escalated technical issues',
    tags: ['support', 'escalation', 'tier-2'],
    lastUpdated: '2024-04-11T11:40:00Z',
    performance: { reliability: 97, efficiency: 91, satisfaction: 94 }
  },
  {
    id: 'echo-voice',
    name: 'Echo',
    tier: 'Channel',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Voice interaction and phone system integration',
    tags: ['voice', 'phone', 'ivr'],
    lastUpdated: '2024-04-11T10:30:00Z',
    performance: { reliability: 88, efficiency: 84, satisfaction: 87 }
  },
  {
    id: 'nova-onboarding',
    name: 'Nova',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Employee and broker onboarding automation',
    tags: ['onboarding', 'hr', 'automation'],
    lastUpdated: '2024-04-11T09:10:00Z',
    performance: { reliability: 93, efficiency: 88, satisfaction: 91 }
  },
  {
    id: 'titan-compliance',
    name: 'Titan',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Regulatory filing and compliance automation',
    tags: ['regulatory', 'compliance', 'filing'],
    lastUpdated: '2024-04-11T08:45:00Z',
    performance: { reliability: 90, efficiency: 85, satisfaction: 88 }
  },
  {
    id: 'cipher-security',
    name: 'Cipher',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Security monitoring and threat intelligence',
    tags: ['security', 'monitoring', 'threats'],
    lastUpdated: '2024-04-11T12:10:00Z',
    performance: { reliability: 99, efficiency: 96, satisfaction: 97 }
  },
  {
    id: 'pulse-health',
    name: 'Pulse',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'System health monitoring and alerting',
    tags: ['health', 'monitoring', 'alerts'],
    lastUpdated: '2024-04-11T12:15:00Z',
    performance: { reliability: 98, efficiency: 95, satisfaction: 96 }
  },
  {
    id: 'relay-integration',
    name: 'Relay',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Third-party API integration and data relay',
    tags: ['integration', 'api', 'data'],
    lastUpdated: '2024-04-11T10:20:00Z',
    performance: { reliability: 94, efficiency: 90, satisfaction: 92 }
  },
  {
    id: 'scout-research',
    name: 'Scout',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Market research and competitive intelligence',
    tags: ['research', 'market', 'intelligence'],
    lastUpdated: '2024-04-11T09:55:00Z',
    performance: { reliability: 86, efficiency: 82, satisfaction: 84 }
  },
  {
    id: 'forge-etl',
    name: 'Forge',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'ETL pipelines and data transformation engine',
    tags: ['etl', 'data', 'pipeline'],
    lastUpdated: '2024-04-11T11:15:00Z',
    performance: { reliability: 97, efficiency: 94, satisfaction: 95 }
  },
  {
    id: 'nexus-portal',
    name: 'Nexus',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Unified portal orchestration and module management',
    tags: ['portal', 'orchestration', 'ui'],
    lastUpdated: '2024-04-11T12:20:00Z',
    performance: { reliability: 95, efficiency: 92, satisfaction: 93 }
  },
  {
    id: 'argus-audit',
    name: 'Argus',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Audit trail monitoring and compliance reporting',
    tags: ['audit', 'compliance', 'reporting'],
    lastUpdated: '2024-04-11T10:05:00Z',
    performance: { reliability: 96, efficiency: 91, satisfaction: 93 }
  },
  {
    id: 'horizon-forecast',
    name: 'Horizon',
    tier: 'Experimental',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Long-range market forecasting and scenario modeling',
    tags: ['forecast', 'modeling', 'market'],
    lastUpdated: '2024-04-11T08:30:00Z',
    performance: { reliability: 79, efficiency: 77, satisfaction: 80 }
  },
  {
    id: 'summit-executive',
    name: 'Summit',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Alpha',
    description: 'Executive briefing and board report generation',
    tags: ['executive', 'reports', 'briefing'],
    lastUpdated: '2024-04-11T07:50:00Z',
    performance: { reliability: 88, efficiency: 85, satisfaction: 90 }
  },
  {
    id: 'compass-navigation',
    name: 'Compass',
    tier: 'Channel',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Borrower journey orchestration and navigation',
    tags: ['borrower', 'journey', 'navigation'],
    lastUpdated: '2024-04-11T09:40:00Z',
    performance: { reliability: 92, efficiency: 87, satisfaction: 91 }
  },
  {
    id: 'prism-analytics',
    name: 'Prism',
    tier: 'Specialized',
    status: 'Active',
    verdictMaturity: 'Beta',
    description: 'Multi-dimensional data analytics and visualization',
    tags: ['analytics', 'visualization', 'data'],
    lastUpdated: '2024-04-11T10:35:00Z',
    performance: { reliability: 93, efficiency: 89, satisfaction: 92 }
  },
  {
    id: 'beacon-alerts',
    name: 'Beacon',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Real-time alerting and notification dispatch',
    tags: ['alerts', 'notifications', 'realtime'],
    lastUpdated: '2024-04-11T12:00:00Z',
    performance: { reliability: 98, efficiency: 95, satisfaction: 96 }
  },
  {
    id: 'flux-workflow',
    name: 'Flux',
    tier: 'Specialized',
    status: 'Maintenance',
    verdictMaturity: 'Beta',
    description: 'Dynamic workflow routing and exception handling',
    tags: ['workflow', 'routing', 'exceptions'],
    lastUpdated: '2024-04-10T16:00:00Z',
    performance: { reliability: 91, efficiency: 87, satisfaction: 89 }
  },
  {
    id: 'sentinel-guard',
    name: 'Sentinel',
    tier: 'Platform',
    status: 'Active',
    verdictMaturity: 'Production',
    description: 'Access control and permission management',
    tags: ['access', 'permissions', 'security'],
    lastUpdated: '2024-04-11T11:50:00Z',
    performance: { reliability: 99, efficiency: 97, satisfaction: 98 }
  }
];

export const recentAlerts: Alert[] = [
  {
    id: 'alert-001',
    timestamp: '2024-04-11T12:30:00Z',
    type: 'Critical',
    description: 'Otto underwriting engine experiencing high latency',
    affectedSystem: 'Otto',
    severity: 'High',
    status: 'Open',
    assignee: 'Engineering Team'
  },
  {
    id: 'alert-002',
    timestamp: '2024-04-11T11:45:00Z',
    type: 'Warning',
    description: 'FALLOUT prediction accuracy below threshold',
    affectedSystem: 'FALLOUT',
    severity: 'Medium',
    status: 'Acknowledged',
    assignee: 'Analytics Team'
  },
  {
    id: 'alert-003',
    timestamp: '2024-04-11T10:15:00Z',
    type: 'Info',
    description: 'Scheduled maintenance completed for Zeus oversight',
    affectedSystem: 'Zeus',
    severity: 'Low',
    status: 'Resolved'
  },
  {
    id: 'alert-004',
    timestamp: '2024-04-11T09:30:00Z',
    type: 'Warning',
    description: 'Orion wholesale channel showing increased error rate',
    affectedSystem: 'Orion',
    severity: 'Medium',
    status: 'Open',
    assignee: 'Channel Team'
  },
  {
    id: 'alert-005',
    timestamp: '2024-04-11T08:20:00Z',
    type: 'Critical',
    description: 'Database connection pool exhaustion in production',
    affectedSystem: 'Infrastructure',
    severity: 'Critical',
    status: 'Resolved',
    assignee: 'DevOps Team'
  }
];

export const fleetStatus: FleetStatus = {
  active: 37,
  inactive: 2,
  maintenance: 3,
  total: 42
};

export const wasteMetrics: WasteMetric[] = [
  { category: 'Process Redundancy', current: 12, target: 8, status: 'warning' },
  { category: 'Manual Interventions', current: 15, target: 20, status: 'good' },
  { category: 'Data Re-entry', current: 8, target: 5, status: 'warning' },
  { category: 'Exception Handling', current: 22, target: 25, status: 'good' },
  { category: 'Quality Defects', current: 6, target: 3, status: 'poor' }
];

export const pipelineRisks: PipelineRisk[] = [
  { category: 'Documentation Risk', value: 23, color: '#EF4444' },
  { category: 'Credit Risk', value: 18, color: '#F59E0B' },
  { category: 'Market Risk', value: 15, color: '#10B981' },
  { category: 'Operational Risk', value: 12, color: '#3B82F6' },
  { category: 'Compliance Risk', value: 8, color: '#8B5CF6' }
];

export const roleModuleMapping: Record<string, string[]> = {
  'Executive': ['Command Center', 'Otto', 'Analytics', 'Kronos'],
  'IT/Dev': ['Fleet', 'Foundation', 'Admin', 'Channels'],
  'Operations': ['Command Center', 'Otto', 'Kronos'],
  'Channel': ['Channels', 'Fleet', 'Ally']
};